import PropTypes from "prop-types";

import Presenter from "utils/PropTypesPresenter";

export default new Presenter(
  {
    id: PropTypes.string,
    type: PropTypes.string,
    desktopImage: PropTypes.string,
    name: PropTypes.string,
    rank: PropTypes.number,
    url: PropTypes.string,
  },
  {},
);
